/** Virtual DOM Node */
export function VNode() {}



// WEBPACK FOOTER //
// ../src/vnode.js